import { AllFlyerFilters } from '@/graphql/types';
import { createContext, useContext } from 'react';

export type DrawerFilters = Pick<
  AllFlyerFilters,
  'owningType' | 'categories' | 'grades' | 'isCommunityFree'
>;

export type JarFlyerboardContextType = {
  toggleQuickFilter: (tag: string) => void;
  drawerFilters: DrawerFilters;
  setDrawerFilters: (value: DrawerFilters) => void;
  filters?: AllFlyerFilters;
  resetQuickFilters: () => void;
  amountActiveFilters: number;
  districtId?: string;
};

const JarFlyerboardContext = createContext<JarFlyerboardContextType>({
  toggleQuickFilter: (tag: string) => null,
  resetQuickFilters: () => null,
  amountActiveFilters: 0,
  drawerFilters: {},
  setDrawerFilters: (value?: DrawerFilters) => null,
  districtId: undefined,
  filters: {
    allDistrictSchools: false,
    schoolIds: [],
    categories: [],
    grades: [],
    isNew: false,
    isCommunityFree: false,
  },
});

export const useJarFlyerboardContext = () => useContext(JarFlyerboardContext);

export default JarFlyerboardContext;
